import { isSafe } from "@lib/object"
import { css, FlattenInterpolation, ThemeProps } from "styled-components"

import { Colors, Theme, Spacing, TColor, TUnit, ViewPorts } from "../styles"

export type TOmit = false | null
export type TCssResult = FlattenInterpolation<ThemeProps<Theme>>

export const unit2css = (
  field?: TUnit,
  omit: TOmit = false,
): string | TOmit => {
  if (!isSafe(field)) return omit
  if (typeof field === "number") return `${field}px`
  // @ts-ignore
  if (Spacing[field as string]) return `${Spacing[field as string]}px`
  return field ?? omit
}

export const color2css = (color?: TColor): string | false => {
  if (!isSafe(color)) return false
  // @ts-ignore
  if (Colors[color as string]) return Colors[color as string]
  return color ?? false
}

export function mediaPropsToCss<T>(
  mediaKey: string,
  // @ts-ignore
  props,
  generateCss: (params: T) => TCssResult,
): TCssResult {
  return css`
    ${props?.[mediaKey]?.laptop &&
    css`
      ${ViewPorts.laptop} {
        ${generateCss(props?.[mediaKey]?.laptop)}
      }
    `}

    ${props?.[mediaKey]?.large_desktop &&
    css`
      ${ViewPorts.large_desktop} {
        ${generateCss(props?.[mediaKey]?.large_desktop)}
      }
    `}

    ${props?.[mediaKey]?.desktop &&
    css`
      ${ViewPorts.desktop} {
        ${generateCss(props?.[mediaKey]?.desktop)}
      }
    `}

    ${props?.[mediaKey]?.touch &&
    css`
      ${ViewPorts.touch} {
        ${generateCss(props?.[mediaKey]?.touch)}
      }
    `}

    ${props?.[mediaKey]?.tablet &&
    css`
      ${ViewPorts.tablet} {
        ${generateCss(props?.[mediaKey]?.tablet)}
      }
    `}

    ${props?.[mediaKey]?.laptop_small &&
    css`
      ${ViewPorts.laptop_small} {
        ${generateCss(props?.[mediaKey]?.laptop_small)}
      }
    `}

    ${props?.[mediaKey]?.tablet_new &&
    css`
      ${ViewPorts.tablet_new} {
        ${generateCss(props?.[mediaKey]?.tablet_new)}
      }
    `}

    ${props?.[mediaKey]?.mobile &&
    css`
      ${ViewPorts.mobile} {
        ${generateCss(props?.[mediaKey]?.mobile)}
      }
    `}

    ${props?.[mediaKey]?.desktop_new &&
    css`
      ${ViewPorts.desktop_new} {
        ${generateCss(props?.[mediaKey]?.desktop_new)}
      }
    `}

    ${props?.[mediaKey]?.tablet_new &&
    css`
      ${ViewPorts.tablet_new} {
        ${generateCss(props?.[mediaKey]?.tablet_new)}
      }
    `}
  `
}
